/**
 * Browser urls
 */
export enum EvidenceBrowserUrl {
  HOME = '/',
  ADMIN_SOAP_MESSAGES = '/soap-messages',
  ALOG = '/alog',
  APP_SETTINGS = '/app-settings',
  DATA_SOURCE = '/data-source',
  EXPORT_REQUESTS = '/export-requests',
  EXPORT_TEMPLATES = '/export-templates',
  USERS = '/users',
  IMPORTS = '/imports',
  INTERNAL_SETTINGS = '/settings',
  IP_ENTRY = '/ip-entry',
  MPT = '/mpt',
  PARAGRAPH = '/paragraph',
  SEQUENCES = '/sequences',
  SCHEDULE_JOBS = '/schedule-jobs',
  SCHEDULE_RUNS = '/schedule-runs',
  SYSTEM_USERS = '/system-users',
  RESEARCH_QUERY = '/research-query',
  IMPORT_REQUEST = '/import-request',
  NON_STANDARD_STATE = '/non-standard-state',
  CUSTOM_DEVELOPER_TOOLS = '/custom-developer-tools',
}

export enum EvidenceApiUrl {
  DATA_SOURCE = '/api/tapis/data-source',
  IMPORTS = '/api/tapis/imports',
  INTERNAL_SETTINGS = '/api/tapis/settings',
  IP_ENTRY = '/api/tapis/ip-entry',
  PARAGRAPH = '/api/tapis/paragraph',
  RESEARCH_QUERY = '/api/tapis/research-query',
  USERS = '/api/tapis/user',
  SYSTEM_USERS = '/api/tapis/user/external',
  IMPORT_REQUEST = '/api/tapis/import-request',
  NON_STANDARD_STATE = '/api/tapis/non-standard-state',
  MPT = '/api/tapis/mpt',

  NON_STANDARD_STATE_AUTOCOMPLETE = '/api/tapis/non-standard-state/autocomplete',
}
